<template>
  <div class="p-4">
    <l-container class="mb-4">
      <l-container-title
        slot="toolbar"
        :text= "this.$t('observations')"
        icon="network-wired"
        color="bg-pastel-purple"
      />
    </l-container>

    <input class="block mb-2 text-sm font-medium text-gray-900 dark:text-white" id="search_field" type="search" placeholder="Search">
  
    <hot-table :data="observations" :settings="settings" ref="hot" :key="componentKey">
      <hot-column :title= "this.$t('from')"  :renderer="epochRenderer" data="timestamp_from_epoch" read-only="true"></hot-column>
      <hot-column :title= "this.$t('to')"  :renderer="epochRenderer" data="timestamp_to_epoch" read-only="true"></hot-column>
      <hot-column title= "ID" data="id" read-only="true"></hot-column>
      <hot-column :title= "this.$t('name')" data="name" read-only="true"></hot-column>
      <hot-column :title= "this.$t('component')"  data="component" read-only="true"></hot-column>
      <hot-column :title= "this.$t('value')" data="value" read-only="true"></hot-column>
      <hot-column :title= "this.$t('unit')" data="unit" read-only="true"></hot-column>
      <hot-column :title= "this.$t('datalevel')" data="level" read-only="true"></hot-column>
      <hot-column title="lat" data="latitude" read-only="true"></hot-column>
      <hot-column title="lon" data="longitude" read-only="true"></hot-column>
      <hot-column title="QC" :renderer="qcbitflagsrenderer" data="qc_flags.flags" read-only="true"></hot-column>
    </hot-table>
  </div>
</template>

<script>
import ContextMenu from "./context.menu";
import HandsontableHelper from "@/helpers/settings/handsontable";
import "handsontable/dist/handsontable.full.css";
import { HotTable, HotColumn } from "@handsontable/vue";
import Handsontable from "handsontable";
import ObservationsService from "../../helpers/apiservices/observations/observations.service";
import SensorsService from "../../helpers/apiservices/sensors/sensors.service";

import Notify from "@/helpers/notify";

var obshottable;

export default {
  name: "observations",
  components: {
    HotTable,
    HotColumn,
    //LInput,
    //LButton,
    //LInfoBox,
  },
  data() {
    return {
      epochRenderer: HandsontableHelper.epochRenderer,
      qcbitflagsrenderer : HandsontableHelper.qcbitflagsrenderer,
      observations: [],
      sensors: [],
      componentKey: 0,
      settings: HandsontableHelper.settings(false),
    };
  },
  mounted() {
    this.settings.afterSelectionEnd = this.selectRowOnly;
    this.settings.dropdownMenu = false;
    this.settings.contextMenu = ContextMenu(this);
    this.loadInitialData();
    //Notify.loadData(null, this.loadInitialData);

    //forcing recreation of hot-table since nor re-rendering of table or edit settings updated headers
    this.$root.$on('rendertable', () => {
      this.componentKey += 1;
    }); 

    obshottable = this.$refs.hot.hotInstance;

    //search fields listenere
    const searchField = document.querySelector('#search_field');
    searchField.addEventListener('keyup', function(event) {
      const search = obshottable.getPlugin('search');
      const queryResult = search.query(event.target.value);
      obshottable.render();
    });

  },

  methods: {
    async loadInitialData() {

      this.sensors = await SensorsService.sensors();
      let obs = await ObservationsService.observationsasync();

      //Add name property
      obs.forEach(ob => {
        ob.name = this.sensors.find(obj => obj.id == ob.id).name;
      });

      this.observations = obs;
      
    },

  }
};
</script>